let workspaceGeneration = 0;

export const captureWorkspaceGeneration = (): number => workspaceGeneration;

export const isWorkspaceGenerationCurrent = (generation: number): boolean =>
  generation === workspaceGeneration;

export const advanceWorkspaceGeneration = (): number => {
  workspaceGeneration += 1;
  return workspaceGeneration;
};

export const runWorkspaceRequest = async <T,>(
  request: () => Promise<T>,
): Promise<T | undefined> => {
  const generation = captureWorkspaceGeneration();

  try {
    const result = await request();
    return isWorkspaceGenerationCurrent(generation) ? result : undefined;
  } catch (error) {
    if (!isWorkspaceGenerationCurrent(generation)) {
      return undefined;
    }
    throw error;
  }
};
